import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import $ from 'jquery';
import SelectDropdown from './SelectDropdown';
import RadioButtons from './RadioButtons';

class SignupForm extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {	
			username_newacc: '',
			password_newacc: '',
			confirmpassword_newacc: '',
			singupType:"userid",
			loginType:this.props.loginType || "userid",
			userInput:this.props.userInput || "",
			otp_newacc: '',				
			submitButtonDisabled: false,
			serverMessage: "",
			emailfeedbackmsg: "",
			source:"plp",
			isOTPSend:false,
			isVerified:false,
			OTPDisabled:"hiddenOTP",
			verifyDisabled:"disabled",
			emailDisabled:false,
			phoneDisabled:false,
			verifyText:this.rb("register.verify"),
			sendOTPText:this.rb("register.sendOTP"),
			passcodeDisabled:"disabled",
			selectedRole:"STU"
		};
		
		this.classesTeaching = null;
		//this.selectedRole = null;
		this.userReferal = null;

		this.navigationKey="PLP_Navigation";

		this.handleChange = this.handleChange.bind(this);		
		this.enterOTPChange = this.enterOTPChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.userIdChange = this.userIdChange.bind(this);
		this.googleLogin = this.googleLogin.bind(this);
		
		this.sendOTP = this.sendOTP.bind(this);
		this.verifyOTP = this.verifyOTP.bind(this);
		this.getOTPField = this.getOTPField.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);

		this.radioSelected = this.radioSelected.bind(this);
		this.setCentaReference = this.setCentaReference.bind(this);
		this.setUserOrigin = this.setUserOrigin.bind(this);
		this.setClassesForTCHR = this.setClassesForTCHR.bind(this);
		this.googleLogin = this.googleLogin.bind(this);
		this.isFreeTrialAllowed = this.isFreeTrialAllowed.bind(this);

		this.myTrackerInstance = this.getTracker();
		
		this.gaFrom = this.props.gaFrom;
		console.log("this.gaFrom:::::::::::",this.gaFrom);
		if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
			this.gaFrom = this.gaFrom+" Home - Join";
		}else{
			this.gaFrom = "Users who have independently registered - Sign Up";
		}
		console.log("this.gaFrom2222:::::::::::",this.gaFrom);
	}

	isFreeTrialAllowed(val){
		let userRole = val || null;  
		if(userRole && userRole.length > 1 && window.noFreeTrialRoles && window.noFreeTrialRoles.length > 0){
			return  !(~window.noFreeTrialRoles.indexOf(userRole));
		}

	  	//user not logged in or role not defined latter is unlikely or no suppression in window.noFreeTrialRoles
	  	return true;
	  }

	  componentWillReceiveProps(nextProps) {
	  	var me = this;

	  	this.gaFrom = nextProps.gaFrom;
	  	console.log("this.gaFrom:::::::::::",this.gaFrom);
	  	if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
	  		this.gaFrom = this.gaFrom+" Home - Join";
	  	}else{
	  		this.gaFrom = "Users who have independently registered - Sign Up";
	  	}

	  	console.log("this.gaFrom:::::::::::",this.gaFrom);
	  	console.log('componentWillReceiveProps', nextProps);    
	  	this.setState({	
	  		loginType:nextProps.loginType || "userid",
	  		userInput:nextProps.userInput || "",
	  		otp_newacc: '',				
	  		submitButtonDisabled: false,
	  		serverMessage: "",
	  		emailfeedbackmsg: "",
	  		source:"plp",
	  		isOTPSend:false,
	  		isVerified:false,
	  		OTPDisabled:"hiddenOTP",
	  		verifyDisabled:"disabled",
	  		emailDisabled:false,
	  		phoneDisabled:false,
	  		verifyText:this.rb("register.verify"),
	  		sendOTPText:this.rb("register.sendOTP"),
	  		passcodeDisabled:"disabled"
	  	});
	  	setTimeout(function(){
	  		me.reinitiate();
	  	},500)

	  }
	  componentDidMount(){
	  	var me = this;
	  	this.sessionCheck();
	  	setTimeout(function(){
	  		me.reinitiate();
	  	},200);		
	  } 

	  reinitiate(){		
	  	console.log("reinitiate gaFrom:::::::::::",this.gaFrom);
	  	if(this.state.userInput != ""){
	  		this.form.validateFields();
	  		this.setState({ submitButtonDisabled: !this.form.isValid() });
	  		if(this.form.isValid()){
	  			this.setState({ OTPDisabled: ""});			
	  			$(".OTPButton").trigger("click");
	  		}
	  	}

	  	$("#loginRoot .userInput").focus();
	  }

	  handleChange(e) {
	  	const target = e.currentTarget;	
		//console.log("target=",target);
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled: !this.form.isValid()
		});
	}
	userIdChange(e){
		const target = e.currentTarget;
		this.form.validateFields(target);
		
		var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		
		if(phoneRegx.test(target.value)){
			this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
			if(target.value.length >= 10){				
				this.setState({ OTPDisabled: "",passcodeDisabled:""});
			}
		}else{
			this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
			//this.setState({ [target.name]: "hidden",isOTPSend:false,isVerified:false,password_newacc:""});
			if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
				this.setState({ OTPDisabled: "",passcodeDisabled:""});
			}
		}
		
		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled:true
		});
		
	}
	
	enterOTPChange(e){
		if(this.otp.value.length > 0){
			this.setState({ verifyDisabled: ""});
		}else{
			this.setState({ verifyDisabled: "disabled"});
		}
		this.handleChange(e);
	}
	
	hmNav = function(userObj){		
		if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR"){
			window.top.location.href = "/teachers";
		}else{
			window.top.location.href = this.props.navigateURL;
		}	

		//this.props.myProps.history.push(this.props.navigateURL);
		
	}

	//Shyam
	setClassesForTCHR = function(evt){
		if(evt && evt.length > 0){
			this.classesTeaching = this.rb("dropdown.classes.tchr.prefix");
			for(let i=0;i<evt.length;i++){		
				if(evt[i] && evt[i].label && evt[i].label.length > 0 ){
					let evtArr = evt[i].label.split(" ");
					this.classesTeaching += evtArr[evtArr.length-1] + ",";
				}	
			}

			this.classesTeaching = this.classesTeaching.substr(0,this.classesTeaching.length-1);
		//console.log("lalalalla:::", this.classesTeaching);
	}
}

setUserOrigin(referal){
	this.userReferal = referal;
}

setCentaReference(evt){
	if(evt && evt.currentTarget && evt.currentTarget.value){
		if(evt.currentTarget.value.length > 0 && evt.currentTarget.value.toLowerCase() === "yes"){
			this.setUserOrigin("centa");
		}		
	}
}

updateUserType(commonCallback){
	var me=this;
	var callBackSuccess = function(response){
		if(response!== null){
			//console.warn("user type",response)
			me.getUser().store(response);
		}

		if(typeof commonCallback === "function"){
			commonCallback.apply(this);
		}
	}

	var callBackFailure = function(response){
		//console.warn("failure ",response);

		if(typeof commonCallback === "function"){
			commonCallback.apply(this);
		}
	}

	super.updateUserType(callBackSuccess,callBackFailure)
}


submitForm = function(){		
	var verificationtype = this.state.loginType;
	var formData = {
		"userName" : this.state.username_newacc,
		"loginId" : this.state.userInput,
		"userRole" : {
			"role" : this.state.selectedRole || "STU",
			"level": "1"
		},				
		"token" : this.state.otp_newacc,
		"countryCode" : "IN",
		"password" : this.state.password_newacc,
		"verificationType" : verificationtype,
		"regnProvider" : "heymath",
				"schoolName":this.state.schoolname_newacc, //Shyam
				"location":this.state.address_newacc,
				"classesTeaching":this.classesTeaching,
				"userOrigin":this.userReferal
			}
			if(this.state.loginType == "mobile"){
				formData["phone"] = this.state.userInput;
			}else{
				formData["email"] = this.state.userInput;
			}

			var me =this;

			me.setState({submitButtonDisabled: true});

			var callBackSuccess = function(response){
				if(response !== null){
					if(response.status.toLowerCase() == "success"){	
						new UserStore().store(response.user);

					//me.props.successRegisterMsg(me.rb("register.success.msg"));
					
					try{
						me.doLumosLogout();
					}catch(e){}
					
					me.trackMe(true,"set_password");
					

					let afterUpdate = function(){
						me.hmNav(response.user);
					};
					me.updateUserType(afterUpdate);
					
				}else{
					
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",submitButtonDisabled:false});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",submitButtonDisabled:false});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",submitButtonDisabled:false});
					}else if(response.status == "empty_inputs"){
						me.setState({serverMessage:"Please enter all the fields",submitButtonDisabled:false});
					}else if(response.status == "token_not_verified"){
						me.setState({serverMessage:"Passcode Verification is required",submitButtonDisabled:false});
					}else if(response.status == "provider_forbidden"){
						me.setState({serverMessage:"Already registered with Gmail ID. Please click continue with Google",submitButtonDisabled:false});
					}
					else{
						me.setState({serverMessage:response.status,submitButtonDisabled:false});
					}
					me.trackMe(false,"set_password");
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_REGISTER");
			me.setState({submitButtonDisabled: false});
			me.showAlert("","Error in CREATE_REGISTER");
			me.trackMe(false,"set_password");
		}

		new HmAjax(this.getUrlFor("CREATE_REGISTER"),formData).post(callBackSuccess,callBackFailure);
		new UserStore().clearOldUser();
	}
	
	trackMe(result,source){			
		var trackObj = {
			"name": this.state.username_newacc,
			"email": (this.state.loginType == "mobile") ? "" : this.state.userInput,
			"phone": (this.state.loginType == "mobile") ? this.state.userInput : "",
			"event_source":this.getTracker().enums.signupEventSource[source],
			"result": result

		}
		
		if(source == "set_password") {
			this.storeTrackEvent("signup", trackObj);
		} else {
			this.initiateTrack("signup",trackObj);
		}
	}

	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   

			if(this.state.isOTPSend && this.state.isVerified){
				this.submitForm();    
			}
		}
	}
	
	sendOTP(){
		if(this.state.OTPDisabled == "hiddenOTP"){
			this.form.validateFields();
			return;
		}
		
		var me =this;
		var otpServerMsg = "";
		
		if(this.state.loginType == "mobile"){
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to mobile";
			}else{
				otpServerMsg = "OTP is sent to your mobile";
			}
		}else{
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to your email";
			}else{
				otpServerMsg = "OTP is sent to your email";
			}
		}
		
		me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});

		var formData = {
			"contactId":this.state.userInput,				
			"contactType":this.state.loginType
		}		

		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",passcodeDisabled:""});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});
					}else{
						me.setState({emailfeedbackmsg:otpServerMsg,passcodeDisabled:""});
					}
				}
				
				if(response.status == "success"){
					me.setState({isOTPSend:true,passcodeDisabled:"disabled"});
					me.trackMe(true,"send_otp");
				}else{
					me.trackMe(false,"send_otp");
				}

			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_SENDVERIFICATION_TOKEN");	
			me.setState({passcodeDisabled:""});
			me.trackMe(false,"send_otp");
		}

		new HmAjax(this.getUrlFor("CREATE_SENDVERIFICATION_TOKEN"),formData).post(callBackSuccess,callBackFailure);
	}
	verifyOTP(){
		var me =this;
		me.setState({serverMessage:""});
		var verificationtype = this.state.loginType;
		var formData = {
			"verificationId":this.state.userInput
		}
		this.setState({verifyDisabled:"disabled"});
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else{
						me.setState({isVerified:true,verifyDisabled: ""});
						me.trackMe(true,"verify_otp");
					}
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_SENDVERIFICATION_TOKEN");	
			me.setState({verifyDisabled:""});
			me.trackMe(false,"verify_otp");
		}

		new HmAjax(this.getUrlFor("CREATE_VERIFY_EMAIL")+verificationtype+"/"+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);
	}
	getOTPField(){
		if(this.state.isOTPSend){
			return(
				<FormGroup for="otp_newacc">
				<FormControlInput type="otp_newacc" className="otp_newacc" name="otp_newacc" placeholder={this.rb("register.enterOTP")}	
				innerRef={otp => this.otp = otp}
				onKeyUp={this.handleKeyUp}
				value={this.state.otp_newacc} onChange={this.enterOTPChange}
				required minLength={1} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
				<FieldFeedbacks for="otp_newacc">
				<FieldFeedback when="valueMissing">{this.rb("register.enterOTP")}</FieldFeedback>
				<FieldFeedback when="*" />
				</FieldFeedbacks>
				</FormGroup>
				);
		}
	}
	getVerifyField(){
		if(this.state.isOTPSend && !this.state.isVerified){
			return (<div className={"submitButton verifyButton "+this.state.verifyDisabled} onClick={this.verifyOTP} >{this.rb("register.verify")}</div>);
		}/*else if(this.state.isOTPSend && this.state.isVerified){
			return (<div className="text-right verifytxt"><i class="material-icons">done</i> <span>{this.rb("register.verified")}</span></div>);
		}*/
		
	}
	getSignupHeaderMsg(){
		if(this.state.isOTPSend && !this.state.isVerified){
			if(this.state.loginType == "mobile"){
				return (
					<div>
					<div><h4>Please verify your number</h4></div>
					<div className="small infogrey mt-10">A 6-digit OTP has been sent to your mobile number for verification</div>
					</div>
					);
			}else{
				return (
					<div>
					<div><h4>Please verify your Email</h4></div>
					<div className="small infogrey mt-10">A 6-digit OTP has been sent to your Email for verification</div>
					</div>
					);
			}
			
		}else if(this.state.isVerified){
			return (
				<div>
				<div><h4>Congratulations</h4></div>
				<div className="small infogrey mt-10">You are almost set. Enter your Name and set password to start learning.</div>
				</div>
				);
		}
		
	}
	sendOTPText(){
		if(this.state.isOTPSend){
			return(this.rb("register.reSendOTP"));
		}else{
			return(this.rb("register.sendOTP"));
		}
	}
	showEmailFeedback(){
		if(this.state.isOTPSend){
			return(
				<div className="form-control-feedback">
				<div className="error">{this.state.emailfeedbackmsg}</div>
				{( () =>{
					if(this.state.loginType == "mobile"){
						return(
						<div className="feedbacksmall"><i>All important information will be sent to this mobile number</i></div>
						);
					}else{
						return(
						<div className="feedbacksmall"><i>All important information will be sent to this email ID</i></div>
						);
					}
				})()}

				</div>
				);
		}
	}
	
	getUserInputPattern(){		
		if(this.state.loginType == "mobile"){
			return ".{10,}";
		}else{
			return "^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";
		}
	}

	radioSelected(evt){
		let val = evt.currentTarget.value;
		if(val && val.length > 0){
			//this.selectedRole = val;
			this.setState({selectedRole:val});
			/*alert(val);*/
		}

		return true;
	}

	getContactType(){
		if(!this.state.isVerified){
			return(
				<div>
				{
					(() => {
						let user = this.props.signupUser || 'student'
						if(user === 'student'){
							return(
								<form className="col-md-12 mt-30 signup-radio">									
								<div className="col-md-6 radio-group">
								<input className="form-check-input" type="radio" name="student" value="STU" id="student_select" onChange={this.radioSelected} defaultChecked/>
								<label className="form-check-label" htmlFor="student_select">Student/Parent</label>
								</div>
								<div className="col-md-6 radio-group">										
								<input className="form-check-input" type="radio" name="student" value="TCHR" id="teacher_select" onChange={this.radioSelected}/>
								<label className="form-check-label" htmlFor="teacher_select">Teacher</label>
								</div>									
								</form>
								)
							}
						})()
					}
					<FormGroup for="userInput">
					{( () => {
						/* if(this.state.loginType == "mobile"){
							return (
							<span className="countrycodeform">+91</span>
							);
						} */
					})()}

					<FormControlInput type="userInput" className={"userInput "+this.state.loginType} name="userInput" placeholder={this.rb("login.userplaceholder")}
					innerRef={email => this.email = email}
					onKeyUp={this.handleKeyUp}
					value={this.state.userInput} onChange={this.userIdChange}
					pattern={this.getUserInputPattern()}
					required minLength={1} maxLength={this.state.loginMaxLength} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="2" />


					{( () => {
						if(this.state.loginType == "mobile"){
							return (
								<FieldFeedbacks for="userInput">
								<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
								<FieldFeedback when="patternMismatch">{this.rb("register.mobilenolength")}</FieldFeedback>
								<FieldFeedback when={value => (value.length>0 && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value))}>{this.rb("register.numbersonly")}</FieldFeedback>							 
								<FieldFeedback when="*" />
								</FieldFeedbacks>
								);
							}else{
								return (
								<FieldFeedbacks for="userInput">
								<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
								<FieldFeedback when="patternMismatch">{this.rb("fpwd.validemail")}</FieldFeedback>														
								</FieldFeedbacks>	
								);
							}
						})()}

						{/*<FieldFeedback when="valueMissing">{this.rb("login.useridrequired")}</FieldFeedback>
					<FieldFeedback when="*" />*/}

					</FormGroup>

					{/*<div className="clearfix">
						<div className="emailfeedback">
							{this.showEmailFeedback()}				
						</div>
					</div>*/}



					<div className="clear clearfix"></div>

					{this.getOTPField()}				

					<div className="clear clearfix"></div>

					<div className="server-messages pt-20">{this.state.serverMessage}</div>

					
					{( () => {
						
						if(this.state.isOTPSend){
							return(
							<div>									
							<div className="clearfix">
							<span>{this.rb("register.reSendOTPmsg")} </span> <span className="pl-10 resendButton" onClick={this.sendOTP}>{this.rb("register.reSendOTP")}</span>
							</div>
							{this.getVerifyField()}
							</div>
							);
						}else{
							return(
							<div>
							{this.getVerifyField()}
							<div>
							<div className={"submitButton OTPButton "+this.state.OTPDisabled+" "+this.state.passcodeDisabled} onClick={this.sendOTP} >{this.rb("register.sendOTP")}</div>
							</div>
							</div>
							);
						}
						
					})()}
					</div>
					);
						}
					}

					getStep2TeachersForm(){
						return (
							<div>
							<FormGroup for="username_newacc">
							<FormControlInput type="username_newacc" className="username_newacc" name="username_newacc" placeholder={this.rb("billing.fullname")}
							value={this.state.username_newacc} onChange={this.handleChange}
							required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
							<FieldFeedbacks for="username_newacc">
							<FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>
							<FieldFeedback when="*" />
							</FieldFeedbacks>
							</FormGroup>
							<FormGroup for="schoolname_newacc">
							<FormControlInput type="schoolname_newacc" className="schoolname_newacc" name="schoolname_newacc" placeholder={this.rb("billing.schoolname")}
							value={this.state.schoolname_newacc} onChange={this.handleChange}
							required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
							<FieldFeedbacks for="schoolname_newacc">
							<FieldFeedback when="valueMissing">{this.rb("billing.schoolrequired")}</FieldFeedback>		
							<FieldFeedback when="*" />
							</FieldFeedbacks>
							</FormGroup>
							<FormGroup for="address_newacc">
							<FormControlInput type="address_newacc" className="address_newacc" name="address_newacc" placeholder={this.rb("billing.location")}
							value={this.state.address_newacc} onChange={this.handleChange}
							required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
							<FieldFeedbacks for="address_newacc">
							<FieldFeedback when="valueMissing">{this.rb("billing.addressrequired")}</FieldFeedback>	
							<FieldFeedback when="*" />
							</FieldFeedbacks>
							</FormGroup>
							<FormGroup for="class_dropdown" className="classSelection">  
							<SelectDropdown callBack={this.setClassesForTCHR}></SelectDropdown>
							<FieldFeedbacks for="class_dropdown">
							<FieldFeedback when="valueMissing">{this.rb("billing.classrequired")}</FieldFeedback>	
							<FieldFeedback when="*" />
							</FieldFeedbacks> 
							</FormGroup>
							<FormGroup for="member_newacc" className="col-md-12 mt-30 signup-radio pad-left">								
							<h6 className="col-md-8 radio-section">{this.rb("centa.heading")}</h6>
							<RadioButtons callBack={this.setCentaReference}></RadioButtons>	
							<FieldFeedbacks for="member_newacc">
							<FieldFeedback when="valueMissing">{this.rb("billing.memberrequired")}</FieldFeedback>	
							<FieldFeedback when="*" />
							</FieldFeedbacks> 
							</FormGroup>
							<FormGroup for="password_newacc">
							<FormControlInput type="password" className="password_newacc" name="password_newacc" placeholder={this.rb("login.password")}						
							innerRef={password => this.password = password}
							value={this.state.password_newacc} onChange={this.handleChange}
							required minLength={6} maxLength={50}  autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" />
							<FieldFeedbacks for="password_newacc">
							<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
							<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
							</FieldFeedbacks>
							</FormGroup>

							<FormGroup for="confirmpassword">
							<FormControlInput type="password" className="confirmpassword_newacc" name="confirmpassword_newacc" placeholder={this.rb("rpwd.confirmpwd")}
							innerRef={confirmpassword => this.confirmpassword = confirmpassword}
							value={this.state.confirmpassword_newacc} onChange={this.handleChange}				
							required minLength={6} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5" />

							<FieldFeedbacks for="confirmpassword_newacc">
							<FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
							<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
							<FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
							</FieldFeedbacks>					
							</FormGroup>

							<div className="clear clearfix"></div>

							<div className="server-messages pt-20">{this.state.serverMessage}</div>
							</div>
							)
}

getStep2StudentsForm(){
	return(
		<div>
		<FormGroup for="username_newacc">
		<FormControlInput type="username_newacc" className="username_newacc" name="username_newacc" placeholder={this.rb("billing.fullname")}
		value={this.state.username_newacc} onChange={this.handleChange}
		required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
		<FieldFeedbacks for="username_newacc">
		<FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>					 
		<FieldFeedback when="*" />
		</FieldFeedbacks>
		</FormGroup>
		<FormGroup for="password_newacc">
		<FormControlInput type="password" className="password_newacc" name="password_newacc" placeholder={this.rb("login.password")}						
		innerRef={password => this.password = password}
		value={this.state.password_newacc} onChange={this.handleChange}
		required minLength={6} maxLength={50}  autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" />
		<FieldFeedbacks for="password_newacc">
		<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
		<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
		</FieldFeedbacks>
		</FormGroup>

		<FormGroup for="confirmpassword">
		<FormControlInput type="password" className="confirmpassword_newacc" name="confirmpassword_newacc" placeholder={this.rb("rpwd.confirmpwd")}
		innerRef={confirmpassword => this.confirmpassword = confirmpassword}
		value={this.state.confirmpassword_newacc} onChange={this.handleChange}				
		required minLength={6} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5" />

		<FieldFeedbacks for="confirmpassword_newacc">
		<FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
		<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
		<FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
		</FieldFeedbacks>					
		</FormGroup>

		<div className="clear clearfix"></div>

		<div className="server-messages pt-20">{this.state.serverMessage}</div>
		</div>
		);

}


setPassword(){
	if(this.state.isVerified){
		if(this.state.selectedRole === "TCHR"){
			return this.getStep2TeachersForm();
		}else{
			return this.getStep2StudentsForm();
		}
	}		
}
googleLogin(){
	var navigateObj = {
		navigateURL:this.props.navigateURL
	}
	BrowserStorageUtil.storeSessionItem(this.navigationKey, JSON.stringify(navigateObj));

	if(!this.tracked){
		this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":"signin-googlesignin"});
		this.tracked = true;
	}

	window.top.location.href = this.getUrlFor("GOOGLE_LOGIN_API");
}
handleKeyUp(event) {
	if (event.key === 'Enter' && this.form.isValid()) {	    	
		if(!this.state.isVerified){
			if(this.state.isOTPSend && this.state.verifyDisabled != "disabled"){
				$(".verifyButton").trigger("click");
			}else if(this.state.passcodeDisabled != "disabled"){
				this.setState({ OTPDisabled: ""});
				$(".OTPButton").trigger("click");				
			}
		}

	}
}
GoogleLoginShow(){
	if(this.state.selectedRole === "STU"){ 
		if(this.state.isOTPSend == false){
			return(
				<div className="loginTop pt-15">				
				<div className="text-center josefin mt-20">OR</div>
				<div className="socialLoginContainer text-center">								
				<div className="socialLoginButtons google" onClick={this.googleLogin}>
				<i className="fab fa-google"></i>
				{this.rb("login.google")}
				</div>
				</div>	
				</div>
				);
			}
		}
		else { 
			return(<div></div>)
		}
	}
	render() {
		if(this.state.loggedIn){
			return super.render();
		} else { 
			
			return (
			
			<div className="row nomargin loginParent">
			<div className="col-sm-4 col-lg-4 nopadding loginLeftSection">
			<h1 className="loginLeftContent">{this.rb("unified_login.joinincaptital")}</h1>
			<div className="charactercontainer d-none d-sm-block">
			{(() => {
				if(this.state.selectedRole && this.isFreeTrialAllowed(this.state.selectedRole)){
					return(
					<div>
					{( () => {							
						if(this.props.navigateURL != "/product-details"){
							return (<img className="charactericons freetrailIcon" src={this.getBasePath("/images/icons/plp_app/freetrailicon.png")} />);
						}else if(this.props.freetrail == "true"){
							return (<img className="charactericons freetrailIcon" src={this.getBasePath("/images/icons/plp_app/freetrailicon.png")} />);
						}
					})()}
					</div>					
					)
				}
			})()}
			<img className="charactericons signupIcon" src={this.getBasePath("/images/icons/core/signupicon.png")} />
			</div>

		</div>

		<div id="loginRoot" className="plpLogin col-sm-8 col-lg-8">

		<div className="">

		<div className="row">
		<div className="col-md-12">

		<div className="row">
		<div className="col-md-12 mx-auto">
		<div className="rounded-0">

		{this.getSignupHeaderMsg()}

		<div className="text-center ">

		<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
		onSubmit={this.handleSubmit} noValidate>


		{this.getContactType()}						
		{this.setPassword()}
		<button disabled={this.state.submitButtonDisabled} className={"submitButton signup signupButton "+(this.state.isVerified ? "" : "hidden")}>{this.rb("register.startlearning")}</button>
		<br />


		</FormWithConstraints>	

		{
			(()=>{
				if(this.state.selectedRole=="STU"){
					return(
					this.GoogleLoginShow()
					)
				}
			})()

		}



		</div>
		</div>
		</div>


		</div>

		</div>
		</div>

		</div>



		</div>
		</div>
		);}
	}
}

export default SignupForm;



// WEBPACK FOOTER //
// ./src/views/login/SignupForm.js